/**
 * DONATIONS MAIN COMPONENT - ADMIN VIEW
 * 
 * Orchestrates the Donations feature for the Admin panel.
 * 
 * @module Donations
 */

import React, { useState } from 'react';
import { HandCoins, PlusCircle, RefreshCw, Settings, LayoutDashboard } from 'lucide-react';
import { DonationDashboard } from './components/DonationDashboard';
import { DonationForm } from './components/DonationForm';
import { DonationSettings } from './components/Settings/DonationSettings';
import './Donations.css';
import './components/Settings/Settings.css';

export const Donations: React.FC = () => {
    const [view, setView] = useState<'dashboard' | 'new' | 'settings'>('dashboard');

    return (
        <div className="donations-container">
            {/* Header */}
            <div className="donations-header">
                <div className="header-left">
                    <h2>
                        <HandCoins size={24} className="header-icon" />
                        Donations
                    </h2>
                    <span className="header-badge">
                        {view === 'dashboard' ? 'Financial Health' : 
                         view === 'new' ? 'New Donation' : 
                         'Settings'}
                    </span>
                </div>
                <div className="header-actions">
                    {view === 'dashboard' && (
                        <>
                            <button
                                className="btn-secondary"
                                onClick={() => window.location.reload()}
                                aria-label="Refresh donations"
                            >
                                <RefreshCw size={16} />
                                Refresh
                            </button>
                            <button
                                className="btn-primary"
                                onClick={() => setView('new')}
                                aria-label="Record new donation"
                            >
                                <PlusCircle size={16} />
                                Record Donation
                            </button>
                            <button
                                className="btn-secondary"
                                onClick={() => setView('settings')}
                                aria-label="Donation settings"
                            >
                                <Settings size={16} />
                                Settings
                            </button>
                        </>
                    )}
                    {(view === 'new' || view === 'settings') && (
                        <button
                            className="btn-secondary"
                            onClick={() => setView('dashboard')}
                        >
                            <LayoutDashboard size={16} />
                            Back to Dashboard
                        </button>
                    )}
                </div>
            </div>

            {/* Content */}
            {view === 'dashboard' && <DonationDashboard />}
            {view === 'new' && (
                <DonationForm
                    onSuccess={() => {
                        setView('dashboard');
                    }}
                    onCancel={() => setView('dashboard')}
                />
            )}
            {view === 'settings' && (
                <DonationSettings onBack={() => setView('dashboard')} />
            )}
        </div>
    );
};

export default Donations;
